import RepositoryService from 'src/services/repository'

const resource = 'multiProject/drawConfiguration'

export default RepositoryService.utils.createCrudRepository(resource)
